import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function toISOFrom(dateStr: string) {
  return `${dateStr}T00:00:00.000Z`;
}

export function toISOTo(dateStr: string) {
  return `${dateStr}T23:59:59.999Z`;
}
export type QuickFilter = 'today' | 'yesterday' | 'last7days' | 'last2weeks' | 'last1month' | 'custom';

export function getDateRange(filter: QuickFilter): {
  from: string;
  to: string;
} {
  const today = new Date();
  const fmt = (d: Date) => d.toISOString().split('T')[0];

  switch (filter) {
    case 'today':
      return { from: toISOFrom(fmt(today)), to: toISOTo(fmt(today)) };
    case 'yesterday': {
      const d = new Date(today);
      d.setDate(today.getDate() - 1);
      const s = fmt(d);
      return { from: toISOFrom(s), to: toISOTo(s) };
    }
    case 'last7days': {
      const d = new Date(today);
      d.setDate(today.getDate() - 6);
      return { from: toISOFrom(fmt(d)), to: toISOTo(fmt(today)) };
    }
    case 'last2weeks': {
      const d = new Date(today);
      d.setDate(today.getDate() - 13);
      return { from: toISOFrom(fmt(d)), to: toISOTo(fmt(today)) };
    }
    case 'last1month': {
      const d = new Date(today);
      d.setMonth(today.getMonth() - 1);
      return { from: toISOFrom(fmt(d)), to: toISOTo(fmt(today)) };
    }
    default:
      return { from: toISOFrom(fmt(today)), to: toISOTo(fmt(today)) };
  }
}
